<template>
  <div class="card-body p-xl-40">
    <h6 class="card-title fw-semiBold fs-18 mb-30">
      {{ $t("dashboard_page.top_customers", { month: currentMonth }) }}
    </h6>
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="height: 300px;">
      <span>{{ $t("loading") }}</span>
    </div>
    <div v-else class="chart-body">
      <apexchart
        type="donut"
        width="90%"
        :options="topCustomerChart"
        :series="customer"
      ></apexchart>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import type { DashboardTopCustomerItem } from "@/services/dashboard";

export default defineComponent({
  name: "TopCustomerChart",
  props: {
    items: {
      type: Array as () => DashboardTopCustomerItem[],
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { locale } = useI18n();
    const activeLocale = computed(() =>
      String(locale.value || "en").toLowerCase().startsWith("km")
        ? "km-KH"
        : "en-US"
    );
    const customer = computed(() => props.items.map((item) => Number(item.total_amount || 0)));
    const currentMonth = computed(() =>
      new Date().toLocaleString(
        activeLocale.value,
        { month: "long" }
      )
    );
    
    const topCustomerChart = computed(() => ({
      chart: {
        type: "donut",
        width: "90%",
      },
      toolbar: {
        show: false,
      },
      labels: props.items.map((item) => item.customer_name),
      colors: ["#7F26C6", "#BBBCF1", "#4F46E5", "#FAB134", "#FB5264"],
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        floating: false,
        fontSize: "14px",
        fontWeight: 500,
        inverseOrder: false,
        offsetX: 0,
        offsetY: 0,
        labels: {
          colors: "#838A95",
        },
        markers: {
          width: 16,
          height: 16,
          radius: 2,
          offsetX: 0,
          offsetY: 0,
        },
      },
      stroke: {
        width: 0,
        colors: undefined,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: "bottom",
              fontSize: "10px",
            },
          },
        },
      ],
      tooltip: {
        y: {
          formatter: function (val: number) {
            return "$ " + val.toLocaleString(activeLocale.value, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          },
        },
      },
    }));

    return {
      customer,
      topCustomerChart,
      currentMonth
    };
  },
});
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 380px) {
}
</style>
